import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import useDBO from "../content/hooks/useDBO";
import { UserContext } from "../../Context";
import Lang from "../content/components/Lang";

/**
 * ManualButton - Full-size button linking to the operations manual with an unread count badge.
 * Fetches all manual items and displays the number of unacknowledged items
 * as a red badge on a labeled button, styled like the "New Customer" button.
 *
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
export default function ManualButton() {
  const manualItems = useDBO(`/manual`, 60);

  const unreadCount = useMemo(() => {
    if (!manualItems.get || !Array.isArray(manualItems.get)) return 0;
    return manualItems.get.filter((item) => !item.isAcknowledged).length;
  }, [manualItems.get]);

  if (manualItems.loading) return null;
  if (manualItems.error) return null;

  return (
    <Link to="/manual" className="topbar-manual-btn" aria-label="Operations Manual">
      <BookOpen size={16} strokeWidth={2.5} />
      <span className="topbar-manual-text"><Lang w="manual.manual" /></span>
      {unreadCount > 0 && (
        <span className="topbar-manual-badge">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </Link>
  );
}
